<script>
import {link , push} from 'svelte-spa-router'
import { _ } from "svelte-i18n";
import UserStore from '../stores/user';

export let activeLink;

export let back_link = '/';
export let hide_back = false;

let logout_active = false;
if (typeof appSys === 'undefined') {
  logout_active = true;
}



let isMenuOpen = false;

function toggleMenu() {
  isMenuOpen = !isMenuOpen;
}

const logOut = ()=> {

  UserStore.update(user=>{
    return {};
  })

  push('/login');

}
</script>
  
<style>
  .header {
    background-color: #050A30;
    width: 180px;
    box-sizing: border-box;
    border-left: 1px solid #e4e4e4;

    background-color: #fff;
    border: 0;
    box-shadow: 0px 0px 13px #e1e1e1;
    box-shadow: rgba(17, 43, 85, 0.1) 0px 12px 28px 0px;
    z-index: 3;
  }
  .logo {
    box-sizing: border-box;
    padding: 20px 20px 15px;
  }
  .logo img {
    width: 100%;
  }
  ul {
    list-style: none;
    margin: 0;
    padding:20px;
  }
  a,.logout {
    /* color: #fff;; */
    text-decoration: none;
    display: block;
    padding:5px 0;
    font-size: 14px;;
    cursor: pointer;
  }
  .profile {

    color: #fff;
    padding: 10px 10px;
    background-color: #ca171e;
    font-size: 14px;
    margin: 0 10px;
    border-radius: 70px;
    text-align: center;
  }
  .nav-links ul {
    gap:10px;
    display: flex;
    flex-direction: column;
  }
  .nav-links a {
    display: flex;
    align-items: center;
    /* flex-direction: column; */
    gap:10px;

  }
  .nav-links a i{
    font-size: 13px;
    color: #ca171e;
  }
  .nav-links img {
    position:relative;
    margin-left: 10px;;
    height: 20px;;   
    top:2px; 
  }
  .logout i {
    color: #ca171e;
    margin-left: 5px;;
    font-size: 13px;
  }

</style>

<div class="header">
  <!-- <div class="logo">
    <a href="/home" use:link><img src="images/logo.svg" class="logo"></a>    
  </div> -->

  
  <nav class="mobile-nav">
    <!-- <button class="hamburger" on:click={toggleMenu}>
      <span></span>
      <span></span>
      <span></span>
    </button>
    <div class="overlay" id="overlay" on:click={toggleMenu} class:active={isMenuOpen}></div> -->
    <div class="logo"><img src="{siteUrl}images/{shipping_push_supplier}.svg"></div>
    {#if $UserStore.firstname}
    <!-- <div class="profile">
      <div>   
        <div>{$UserStore.firstname} {#if $UserStore.lastname}{$UserStore.lastname}{/if}</div>
        <div>{$UserStore.company}</div>
      </div>
    </div> -->
    {/if}
    <div class="nav-links" id="nav-links" class:active={isMenuOpen}>
      <ul>
        <!-- <li><a class:active-link="{activeLink === 'customers'}" href="/dashboard" use:link on:click={toggleMenu}><span><img src="images/gettin.svg"></span><span>{$_('header.getting_started')}</span></a></li>
        <li><a class:active-link="{activeLink === 'customers'}" href="/dashboard" use:link on:click={toggleMenu}><span><img src="images/dash.svg"></span><span>{$_('header.dashboard')}</span></a></li>
        <li><a class:active-link="{activeLink === 'customers'}" href="/dashboard" use:link on:click={toggleMenu}><span><img src="images/customers.svg"></span><span>{$_('header.customers')}</span></a></li> -->
        <li>
        {#if crm}
        
          <a class:active-link="{activeLink === 'shipments'}" href="/objects/2" use:link on:click={toggleMenu}>
            <span><i class="fa-solid fa-ticket"></i></span>
            <span>{$_('header.leads')}</span>
          </a>
          <a class:active-link="{activeLink === 'shipments'}" href="/objects/4" use:link on:click={toggleMenu}>
            <span><i class="fa-solid fa-cart-shopping"></i></span>
            <span>{$_('header.orders')}</span>
          </a>
          <a class:active-link="{activeLink === 'shipments'}" href="/objects/46" use:link on:click={toggleMenu}>
            <span><i class="fa-solid fa-cart-shopping"></i></span>
            <span>{$_('header.invoices')}</span>
          </a>
          <a class:active-link="{activeLink === 'shipments'}" href="/objects/1" use:link on:click={toggleMenu}>
            <span><i class="fa-solid fa-users"></i></span>
            <span>{$_('header.customers')}</span>
          </a>
          
        {/if}

          <a class:active-link="{activeLink === 'shipments'}" href="/dashboard" use:link on:click={toggleMenu}>
            <span><i class="fa-solid fa-truck"></i></span>
            <span>{$_('header.shipments')}</span>
          </a>
          <a class:active-link="{activeLink === 'shipments'}" href="/locations" use:link on:click={toggleMenu}>
            <span><i class="fa-solid fa-location-pin"></i></span>
            <span>{$_('header.locations')}</span>
          </a>
          <a class:active-link="{activeLink === 'shipments'}" href="/settings" use:link on:click={toggleMenu}>
            <span><i class="fa-solid fa-gears"></i></span>
            <span>{$_('header.shipping_preferences')}</span>
          </a>
        </li>
      </ul>
      <!-- <ul>
        <li><a class:active-link="{activeLink === 'customers'}" href="/dashboard" use:link on:click={toggleMenu}><span><img src="images/gettin.svg"></span><span>{$_('header.getting_started')}</span></a></li>
        <li><a class:active-link="{activeLink === 'customers'}" href="/dashboard" use:link on:click={toggleMenu}><span><img src="images/dash.svg"></span><span>{$_('header.dashboard')}</span></a></li>
        <li><a class:active-link="{activeLink === 'customers'}" href="/dashboard" use:link on:click={toggleMenu}><span><img src="images/customers.svg"></span><span>{$_('header.customers')}</span></a></li>
        <li><a class:active-link="{activeLink === 'shipments'}" href="/dashboard" use:link on:click={toggleMenu}><span><img src="images/shipments.svg"></span><span>{$_('header.shipments')}</span></a></li>
        <li><a class:active-link="{activeLink === 'shipments'}" href="/dashboard" use:link on:click={toggleMenu}><span><img src="images/rewards.svg"></span><span>{$_('header.rewards')}</span></a></li>
      </ul>
      <ul>
        <li><a class:active-link="{activeLink === 'customers'}" href="/dashboard" use:link on:click={toggleMenu}><span><img src="images/returns.svg"></span><span>{$_('header.returns_replace')}</span></a></li>
        <li><a class:active-link="{activeLink === 'customers'}" href="/dashboard" use:link on:click={toggleMenu}><span><img src="images/history.svg"></span><span>{$_('header.shipping_history')}</span></a></li>
        <li><a class:active-link="{activeLink === 'shipments'}" href="/dashboard" use:link on:click={toggleMenu}><span><img src="images/settings.svg"></span><span>{$_('header.shipping_preferences')}</span></a></li>
      </ul>
      <ul>
        <li><a class:active-link="{activeLink === 'shipments'}" href="/dashboard" use:link on:click={toggleMenu}><span><img src="images/complaints.svg"></span><span>{$_('header.complaints')}</span></a></li>
        <li><a class:active-link="{activeLink === 'shipments'}" href="/dashboard" use:link on:click={toggleMenu}><span><img src="images/chat.svg"></span><span>{$_('header.live_chat')}</span></a></li>
      </ul>
      -->
      {#if logout_active}
      <ul>
        <li>
            <span class="logout" on:click={logOut}>
              <span>
              <i class="fa-solid fa-arrow-right-from-bracket"></i>
            </span>
            <span>{$_('header.logout')}</span>
          </span>
        </li>
      </ul>
      {/if}

    </div>
  </nav>
</div>